<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-text
            name="name"
            label="* Name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
        />

        <input-text
            label="* Key"
            name="key"
            v-model="form.key"
            :error="errors.key ? errors.key[0] : null"
            class="mt-3"
            :disabled="data ? true : false"
        />

        <input-text
            label="Description"
            name="description"
            v-model="form.description"
            :error="errors.description ? errors.description[0] : null"
            class="mt-3"
        />

        <div v-if="form.documents.length">
            <div v-for="(language, index) in languages" :key="index"
                 class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3">
                <p class="text-gray-700 mb-4">Link {{ language.name }} document</p>
                <polymorphic-reference
                    :creatable="false"
                    :language="language"
                    v-model="form.documents[index].document"
                    :models="linkableTypes"
                    :should-open-new-window=true
                    :query="{
                        status_id: 1,
                    }"
                    @input="(document) => documentUpdated(index, document)"
                />
            </div>
        </div>
        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
export default {
    name: "ReferenceLinkForm",
    mixins: [crudForm],
    props: {
        languages: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            form: {
                name: this.getFormData("name"),
                key: this.getFormData("key"),
                description: this.getFormData("description"),
                documents: [],
            },
        };
    },
    mounted: function(){
        this.form.documents = this.languages.map(language => {
            let document = this.extractDocument(language['id']);
            return {
                language_id: language['id'],
                language_name: language['name'],
                document_type: document?.document_type ?? null,
                document_id: document?.document_id ?? null,
                document: document?.document ?? null,
            }
        });
    },
    computed: {
        linkableTypes() {
            return [
                'All Category',
                'Casino Review',
                'Slot Review',
                'Game Review',
                'Home Page',
                'About Us Page',
                'Author',
                'Legal Notice Page',
                'Privacy Policy Page',
                'Cookie Policy Page',
                'Responsible Gambling Page',
                'Payment Method Main Page',
                'License Main Page',
                'Knowledge Hub Page',
                'Blog Main Page',
                'Guide Main Page',
                'Trust Page',
                'Blog',
                'Guide',
                'Html Sitemap',
            ];
        }
    },
    methods: {
        extractDocument: function(languageId){
            if (!this.data){
                return null;
            }
            const documents = this.data.documents.filter(document => document.language_id === languageId)
            if (documents[0]){
                return documents[0];
            } else {
                return null;
            }
        },
        documentUpdated: function (index, document) {
            this.form.documents[index].document_type = document?.model_name || null;
            this.form.documents[index].document_id = document?.id || null;
        },
    },
};
</script>
